import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=4b6fcb60&scoped=true&"
import script from "./uploadfile.vue?vue&type=script&lang=js&"
export * from "./uploadfile.vue?vue&type=script&lang=js&"
import style0 from "./uploadfile.vue?vue&type=style&index=0&id=4b6fcb60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fcb60",
  null
  
)

export default component.exports